<template>
    <div>
        <v-chip close close-icon="mdi-pencil" class="mr-2 my-1 pl-0" small @click:close="close">
        </v-chip>
        <v-chip v-for="(permission, i) in permissionList" :key="i"
                class="mr-2 my-1" small @click:close="close"
                :color="permission.role?'success':'warning'">
            {{permission.id}}
            <span v-if="permission.role!==true&&permission.role!==false">
                : {{permission.role}}</span>
        </v-chip>
    </div>
</template>

<script>
    export default {
        name: "user-admin-roles",
        props: ['userItem'],
        computed: {
            user(){
                return this.$store.state.user;
            },
            permissionList(){
                if ( !this.user || JSON.stringify(this.user.permissions) === '{}' ) {
                    return [];
                }
                let list = [];
                Object.keys(this.userItem.permissions).forEach( (key) => {
                    if ( this.user.permissions.userAdmin.updateRoles.indexOf(key) !== -1 ) {
                        if ( this.userItem.permissions[key] ) {
                            list.push({id: key, role: this.userItem.permissions[key]});
                        }
                    }
                });
                return list;
            }
        },
        methods: {
            close(){
                this.$emit('editUserRoles', {item: this.userItem, action: 'editUserRoles'});
            }
        },
    }
</script>

<style scoped>

</style>